import { render, staticRenderFns } from "./CatNicknameConfirmDialog.vue?vue&type=template&id=1b16d1ff&scoped=true"
import script from "./CatNicknameConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./CatNicknameConfirmDialog.vue?vue&type=script&lang=ts"
import style0 from "./CatNicknameConfirmDialog.vue?vue&type=style&index=0&id=1b16d1ff&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b16d1ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b16d1ff')) {
      api.createRecord('1b16d1ff', component.options)
    } else {
      api.reload('1b16d1ff', component.options)
    }
    module.hot.accept("./CatNicknameConfirmDialog.vue?vue&type=template&id=1b16d1ff&scoped=true", function () {
      api.rerender('1b16d1ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/CatNicknameConfirmDialog.vue"
export default component.exports